import { Phone, MessageSquare } from "lucide-react";

export default function MobileCallButton() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-center gap-2 md:hidden">
      <a
        href="sms:6027770278"
        className="flex items-center gap-2 bg-white text-primary border border-primary/30 px-4 py-3 rounded-full shadow-lg hover:bg-primary/5 active:scale-95 transition-all font-semibold text-sm"
        aria-label="Text Caribbean Breeze HVAC"
        data-testid="mobile-text-button"
      >
        <MessageSquare className="w-4 h-4" />
        Text Us
      </a>
      <a
        href="tel:6027770278"
        className="flex items-center gap-2 bg-primary text-primary-foreground px-4 py-3 rounded-full shadow-lg hover:bg-primary/90 active:scale-95 transition-all font-semibold text-sm"
        aria-label="Call Caribbean Breeze HVAC"
        data-testid="mobile-call-button"
      >
        <Phone className="w-4 h-4" />
        Call Now
      </a>
    </div>
  );
}
